module.exports = __webpack_public_path__ + "images/store_case_study/bersurga-pic1_f9f704a2d7c8c8b422a55ab61d53b8c5.jpg";